module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abs",
    attrs: {
      "id": "basketWindow"
    }
  }, [_c('loader', {
    attrs: {
      "color": 'rgba(255,255,255,0.8)',
      "size": 30,
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "basketList"
  }, [_vm._l((_vm.getMenuList), function(basket) {
    return _c('div', {
      key: basket.id,
      staticClass: "basketItem"
    }, [_c('router-link', {
      staticClass: "basketName pointer",
      attrs: {
        "tag": "a",
        "to": '/basket/basket-list-items/' + basket.id
      }
    }, [_vm._v(_vm._s(basket.name))]), _vm._v(" "), _c('span', {
      staticClass: "countArticles",
      class: {
        active: basket.isCurrent
      }
    }, [_vm._v(_vm._s(basket.nbItems))]), _vm._v(" "), _c('div', {
      staticClass: "basketActions iBlock vMid"
    }, [_c('router-link', {
      staticClass: "viewBasket pointer",
      attrs: {
        "tag": "a",
        "to": '/basket/basket-list-items/' + basket.id
      }
    }, [_vm._v(_vm._s(_vm.$t("basketMenu.viewBasket")))]), _vm._v(" "), _c('span', {
      staticClass: "roundedIcon pointer",
      attrs: {
        "id": _vm.basketInfoId(basket)
      }
    }, [_c('i', {
      staticClass: "fas fa-info"
    })]), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "container": "basketWindow",
        "target": _vm.basketInfoId(basket),
        "placement": "right"
      }
    }, [_c('div', {
      staticClass: "basketInfoToolTip"
    }, [_c('span', [_vm._v("C : " + _vm._s(basket.createdAt) + " by " + _vm._s(basket.createdBy.firstname + " " + basket.createdBy.lastname) + " ")]), _vm._v(" "), _c('span', [_vm._v("M : " + _vm._s(basket.modifiedDate) + " by " + _vm._s(basket.modifiedBy.firstname + " " + basket.modifiedBy.lastname) + " ")])])]), _vm._v(" "), _c('span', {
      staticClass: "roundedIcon pointer",
      on: {
        "click": function($event) {
          _vm.deleteBasketPrompt(basket)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash-alt"
    })])], 1)], 1)
  }), _vm._v(" "), (_vm.countAllBaskets < 1) ? _c('div', [_vm._v(_vm._s(_vm.$t("basketMenu.noBasket")))]) : _vm._e()], 2), _vm._v(" "), (_vm.countAllBaskets > 5) ? _c('footer', [_vm._v(_vm._s(_vm.$t("basketMenu.viewAllBaskets")) + " (" + _vm._s(_vm.countAllBaskets) + ")")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66084c26","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasketMenu/BasketWindow.vue
// module id = 3236
// module chunks = 0